import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-33483f00"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "numeric-value" };
const _hoisted_2 = { key: 0 };
import { ref, watch, inject } from 'vue';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Numeric',
    props: {
        modelValue: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        const props = __props;
        const groupIndex = inject('groupIndex');
        const isInclude = inject('isInclude');
        const { isBetweenOperator } = useAudienceManager(isInclude, groupIndex);
        const numericValue = ref(Array.isArray(props.modelValue) ? [...props.modelValue] : []);
        const emitUpdate = () => {
            emit('update:modelValue', numericValue.value);
        };
        watch(() => props.modelValue, newVal => {
            numericValue.value = Array.isArray(newVal) ? [...newVal] : [];
        }, { immediate: true, deep: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((numericValue.value[0]) = $event)),
                    min: "0",
                    onInput: emitUpdate
                }, null, 544), [
                    [_vModelText, numericValue.value[0]]
                ]),
                (_unref(isBetweenOperator))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('and')), 1))
                    : _createCommentVNode("", true),
                (_unref(isBetweenOperator))
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "number",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((numericValue.value[1]) = $event)),
                        min: "0",
                        onInput: emitUpdate
                    }, null, 544)), [
                        [_vModelText, numericValue.value[1]]
                    ])
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
